var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33464 5.99998H3.33464V14H1.33464C0.966449 14 0.667969 13.7015 0.667969 13.3333V6.66665C0.667969 6.29846 0.966449 5.99998 1.33464 5.99998ZM4.86323 5.13805L9.13023 0.871073C9.2475 0.753773 9.43324 0.74058 9.5659 0.840106L10.1343 1.2664C10.4574 1.50875 10.603 1.92169 10.5034 2.31311L9.7345 5.33331H14.0013C14.7377 5.33331 15.3346 5.93027 15.3346 6.66665V8.06953C15.3346 8.24373 15.3005 8.4162 15.2342 8.5772L13.1713 13.5871C13.0684 13.8369 12.825 14 12.5548 14H5.33464C4.96645 14 4.66797 13.7015 4.66797 13.3333V5.60946C4.66797 5.43265 4.73821 5.26308 4.86323 5.13805Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/liked.b76346c5095eb063e3e984589c84264c.svg";
export { ForwardRef as ReactComponent };